export default __webpack_public_path__ + "static/media/iconeIdoneidadeIntegridade.28ac03ab.svg";